'use client';

import {
  type PropsWithChildren,
  type ReactElement,
  useEffect,
  useState,
} from 'react';

type Props = PropsWithChildren<{ fallback?: ReactElement }>;

export const useIsClient = (): boolean => {
  const [isClient, setIsClient] = useState<boolean>(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient;
};

export const ClientOnly = (props: Props): ReactElement | null => {
  const { children, fallback } = props;
  const isClient = useIsClient();
  return isClient ? <>{children}</> : fallback || null;
};
